import { render } from "./DhSlideOver.vue?vue&type=template&id=731a1f1e"
import script from "./DhSlideOver.vue?vue&type=script&lang=ts"
export * from "./DhSlideOver.vue?vue&type=script&lang=ts"
script.render = render

export default script